import { render, staticRenderFns } from "./breadcrumbs.vue?vue&type=template&id=9f91b830&scoped=true"
import script from "./breadcrumbs.vue?vue&type=script&lang=js"
export * from "./breadcrumbs.vue?vue&type=script&lang=js"
import style0 from "./breadcrumbs.vue?vue&type=style&index=0&id=9f91b830&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f91b830",
  null
  
)

export default component.exports